import { CellContext } from "@tanstack/react-table";
import { useState } from "react";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { SelectFieldOption_Values } from "../../../Definitions";
import { NewFieldStyles, NewFieldTypes } from "../../../Definitions/newFieldStyles";
import { NewCreatableSelect } from "../../BaseComponents";
import { SelectFieldTableOption } from "../_Tables/useColumnConstructor";

interface ListOptions<T> {
  options: SelectFieldTableOption<T>;
  maxValueLength: number | undefined | ((rowId: number) => number);
  regex: boolean | undefined;
}

export const CreatableListTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, divStyleOverride, styleOverrideOnValue = true, options, cell, maxValueLength, regex}: CellContext<T, SelectFieldOption_Values | undefined> & EditAbleCell<T> & ListOptions<T>) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const divStyle = divStyleOverride ? divStyleOverride(styleOverrideOnValue ? value?.label : row.original.id) : undefined;

  const onChange = (newValue: SelectFieldOption_Values | undefined) => {
    setValue(newValue);
  
    // Hvis newValue er undefined, håndter det korrekt
    if (!newValue) {
      table.options.meta?.updateData(row.original.id, column.id, { id: undefined, label: "" }, row);
      return;
    }
    // Hvis newValue har en id, opdater dataen
    if (newValue?.id !== initialValue?.id) {
      table.options.meta?.updateData(row.original.id, column.id, newValue, row);
    }
  };
  let maxLenght;
  if (maxValueLength !== undefined && typeof maxValueLength === "number") {
    maxLenght = maxValueLength;
  }
  if (maxValueLength !== undefined && typeof maxValueLength === "function") {
    maxLenght = maxValueLength(row.original.id);
  }
  if (column.columnDef.id === "day") {
    
  }
  const isStatic = typeof staticColumn === "function" ? staticColumn(row) : staticColumn;
  return <CreatableListStringCell options={typeof options === "function" ? options(row) : options} regex={regex} maxValueLength={maxLenght} staticColumn={isStatic} key={cell.id} keyPass={cell.id+"Input"} onChange={onChange} canEdit={canEdit} cellData={{value, style: divStyle}} />
}

const CreatableListStringCell =<T extends IdentifiableRow,> ({onChange, canEdit, cellData, keyPass, staticColumn, options, maxValueLength, regex}: StyledTableCellProps & EditAbleCell<T> & {options: SelectFieldOption_Values[], maxValueLength: number | undefined, regex: boolean | undefined}) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5  }} key={keyPass}>
          {String(cellData.value.label ?? "") ?? ''}
        </div>
      );
    } else {
      return <NewCreatableSelect
        options={options}
        isSearchable
        isClearable
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary,
          fieldType: NewFieldTypes.tertiaryField,
          fieldWidth: "100%",
          menuWidth: "280px"
        }}
        onChange={onChange}
        key={keyPass}
        valueOverrides={{
          defaultValue: cellData.value,
          maxValueLength,
          regex
        }}
      />;
    }
  }

  return (
    <div style={cellData.style} key={keyPass}>
      {String(cellData.value.label ?? "")}
    </div>
  )
}